var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 36,
    viewBox: "0 0 28 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.9375 35.5V1.375H11.4375C14.4375 1.375 17.1172 2.05469 19.4766 3.41406C21.8516 4.75781 23.7031 6.67969 25.0312 9.17969C26.3594 11.6641 27.0234 14.4922 27.0234 17.6641V19.2344C27.0234 22.4062 26.3672 25.2266 25.0547 27.6953C23.7578 30.1641 21.9219 32.0781 19.5469 33.4375C17.1719 34.7969 14.4922 35.4844 11.5078 35.5H0.9375ZM7.96875 7.07031V29.8516H11.3672C14.1172 29.8516 16.2188 28.9531 17.6719 27.1562C19.125 25.3594 19.8672 22.7891 19.8984 19.4453V17.6406C19.8984 14.1719 19.1797 11.5469 17.7422 9.76562C16.3047 7.96875 14.2031 7.07031 11.4375 7.07031H7.96875Z",
    fill: "url(#paint0_linear_6_11)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_11",
    x1: 13.9804,
    y1: 1.375,
    x2: 13.9804,
    y2: 35.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3477DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A9AE3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 35,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD);
export default __webpack_public_path__ + "static/media/D.87cd05249bec624a0e63a603c8df014f.svg";
export { ForwardRef as ReactComponent };